import { Link } from "react-router-dom";
import { Card, EmptyState, PageHeader } from "@/components/ui";
import { useLeads } from "@/lib/api";

export function LeadsScreen() {
  const leads = useLeads();
  const items = leads.data?.items ?? [];
  return (
    <>
      <PageHeader
        title="Leads"
        subtitle="Contact details visitors left through the widget."
      />
      <Card className="p-0">
        {items.length === 0 ? (
          <EmptyState
            title="No leads yet."
            hint="They appear here the moment a visitor leaves an email in the chat."
          />
        ) : (
          <table className="w-full text-[13px]">
            <thead className="text-left text-[11px] uppercase tracking-wider text-muted">
              <tr>
                <th className="px-5 py-3">Who</th>
                <th className="px-5 py-3">Message</th>
                <th className="px-5 py-3">Page</th>
                <th className="px-5 py-3">When</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {items.map((l) => (
                <tr key={l.id}>
                  <td className="px-5 py-3">
                    <p className="font-medium">{l.name ?? "—"}</p>
                    <p className="text-muted">
                      {l.email}
                      {l.phone ? ` · ${l.phone}` : ""}
                    </p>
                  </td>
                  <td className="max-w-[320px] px-5 py-3">
                    <p className="truncate">{l.message ?? "—"}</p>
                    {l.conversationId ? (
                      <Link
                        to={`/conversations/${l.conversationId}`}
                        className="text-accent"
                      >
                        conversation
                      </Link>
                    ) : null}
                  </td>
                  <td className="max-w-[200px] truncate px-5 py-3 text-muted">
                    {l.pageUrl ?? "—"}
                  </td>
                  <td className="whitespace-nowrap px-5 py-3 text-muted">
                    {new Date(l.createdAt).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </>
  );
}
